import * as angular from 'angular';
import { Attachment } from '../custom';

export class FileModelCtrl implements ng.IController {
    constructor() {}
}

/**
 * Directive due to unsupported ng-model for input type='file'
 *
 * @author bjnowak.btc
 */
class FileModel implements ng.IDirective {
    public restrict = 'A';
    public scope = {
        pkpFileModel: '=?',
        fileName: '=?',
        multipleFiles: '=?',
        fileUploadDate: '=?'
    };
    public controller = FileModelCtrl;

    public link: ng.IDirectiveLinkFn = (
        scope: any,
        elem: JQuery,
        attrs: ng.IAttributes
    ) => {
        elem.bind('change', (changeEvent: JQueryInputEventObject) => {
            scope.$apply(() => {
                let target = changeEvent.target as HTMLInputElement;
                scope.pkpFileModel = target.files[0];
                scope.fileUploadDate = angular.copy(new Date());
                if (!!target.files[0].name) {
                    scope.fileName = angular.copy(target.files[0].name);
                } else {
                    scope.fileName = '';
                }

                scope.multipleFiles = [];
                for (let i = 0; i < target.files.length; i++) {
                    let file: Attachment = {
                        file: target.files[i],
                        name: target.files[i].name || ''
                    };
                    scope.multipleFiles.push(file);
                }
            });
        });
    };
}

angular.module('app').directive('pkpFileModel', () => new FileModel());
